import { render, staticRenderFns } from "./message-abstract-image.vue?vue&type=template&id=0b81b572&scoped=true"
import script from "./message-abstract-image.vue?vue&type=script&lang=ts"
export * from "./message-abstract-image.vue?vue&type=script&lang=ts"
import style0 from "./message-abstract-image.vue?vue&type=style&index=0&id=0b81b572&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b81b572",
  null
  
)

export default component.exports